import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';


@Directive({
  selector: '[duplicateIdentificationType]'
})
export class DuplicateIdentificationTypeDirective {

  public _index:number;
  public _formData:any;

  constructor(private _commonService: CommonService) { }

  @Input()
  public set index(value:number){
    this._index = value;
  }

  @Input()
  public set formData(value:any){
    this._formData = value;
  }
  @Output() duplicateGovIdTypeFound: EventEmitter<any> = new EventEmitter();
  @HostListener('change', ['$event']) onChange(event: any) {
    let governmentIdentificationForm:any = this._formData.get('govermentIdentification');
    const currentIdentification = governmentIdentificationForm.controls[this._index].controls['governmentIdType'].value;
    const currentCountry = governmentIdentificationForm.controls[this._index].controls['country'].value;
    const idType = currentIdentification.identificationType;
    let isDuplicate =  governmentIdentificationForm.controls.find((item,index)=>{
      return index != this._index && item.controls['country'].value == currentCountry && item.controls['governmentIdType'].value.identificationType == idType;
    });
    if(isDuplicate){
      this.duplicateGovIdTypeFound.emit("Multiple "+idType+" are not allowed for same country.");
      //this._commonService.createNotification('',"Multiple "+type+" are not allowed for same country.", NotificationType.ERROR,5000);
      governmentIdentificationForm.controls[this._index].controls['governmentIdType'].setValue('');
      governmentIdentificationForm.controls[this._index].controls['governmentIdType'].updateValueAndValidity();
    }else{
      this.duplicateGovIdTypeFound.emit(null);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/directive/duplicate-identification-type.directive.ts